import { Pencil, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import Modal from "./Modal";
import { ColorPallet } from "pages/Ecommerce/Products/ColorPallet";
import { useState } from "react";
import { ProductColorType } from "types/ProductColorType";
import MultiColorBox from "pages/Ecommerce/Products/MultiColorBox";

interface ProductColorProps {
    productColors: ProductColorType[];
    onStatusChange: (color: ProductColorType) => void;
    onColorSaved: () => void;
    showColorPallet: boolean,
    id:string,
    productVariants?: any[] // Optional: to check if colors are assigned to variants
}

export const ProductColor: React.FC<ProductColorProps> = ({ id, productColors, onStatusChange, onColorSaved, showColorPallet, productVariants = [] }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <div className="flex items-center justify-left flex-wrap" id={id}>
            {productColors.filter((item: ProductColorType) => item.selected).map((item: ProductColorType, index: number) => {
                // Check if this color is assigned to any variant
                const isAssignedToVariant = productVariants.some((variant: any) => 
                    variant.colorCode?.toLowerCase() === item.colorCode?.toLowerCase()
                );
                
                return (
                    <div 
                        className={`multi-color-box-container flex items-center justify-center size-6 border rounded-md ${
                            isAssignedToVariant && item.selected 
                                ? 'border-red-500 dark:border-red-400' 
                                : 'border-slate-500 dark:border-zink-300'
                        }`} 
                        title={`${item.colorName}${isAssignedToVariant && item.selected ? ' (Assigned to variant - cannot deselect)' : ''}`}
                        style={{ 
                            background: item.colorCode, 
                            width: 21, 
                            cursor: isAssignedToVariant && item.selected ? 'not-allowed' : 'pointer', 
                            height: 21, 
                            borderRadius: 3, 
                            textAlign: 'center', 
                            margin: 5,
                            verticalAlign: 'center', 
                            color: (item.selected ? '#dbdbdb' : item.colorCode),
                            opacity: isAssignedToVariant && item.selected ? 0.8 : 1
                        }}
                        onClick={() => onStatusChange(item)}
                        key={"div_color_" + index}
                    >
                        {item.selected && (
                            <div className="checkmark-single">
                                &#10004;
                            </div>
                        )}
                        {isAssignedToVariant && item.selected && (
                            <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border border-white dark:border-zink-700"></div>
                        )}
                    </div>
                );
            })}


            {showColorPallet && (
                <Link to="#!" className="mr-2 flex items-center justify-center size-5 border rounded-sm border-black dark:border-zink-300" style={{ borderRadius: 3, height: 21, width: 21 }} >
                    <Plus className="size-3" onClick={() => setShowModal(true)} />
                </Link>
            )}

            {/* {showColorPicker && (
                <div style={{ position: "absolute", zIndex: 2 }}>
                    <SwatchesPicker onChangeComplete={(newColor: any) => onAddProductColor(newColor)} />
                </div>
            )} */}

            {
                showModal && (
                    <Modal show={showModal} onHide={() => { setShowModal(false) }} id="defaultModal" modal-center="true"
                        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                        dialogClassName="w-screen md:w-[60rem]  md:h-[43rem] bg-white shadow rounded-md dark:bg-zink-600">
                        <ColorPallet key="colorPalletModal"
                            productColors={productColors}
                            onStatusChange={onStatusChange}
                            onColorSaved={() => { setShowModal(false); onColorSaved() }}
                            productVariants={productVariants}
                        ></ColorPallet>
                    </Modal>
                )}
        </div>

    )
}

